export default "__VITE_ASSET__62722d1c__"